export default __webpack_public_path__ + "static/media/thumbnail_protein_plus.60d0f0fb.jpg";